import type { FC } from 'react';
import React, { useState, useCallback } from 'react';
import type { GetTransactionsWithReceiptDto } from '@pflegenavi/shared/api';
import { useNavigate } from 'react-router-dom';
import { fmAppMainPages } from '@pflegenavi/frontend/routing';
import { useUrlsToImages } from '@pflegenavi/shared-frontend/platform';
import { useReceiptImages } from '@pflegenavi/frontend/api-nursing-home';
import { useFileUrlToTypeMapping } from '@pflegenavi/web-components';
import { LatestFMTransactionsView } from './LatestFMTransactionsView';

// ----------------------------------------------------------------------

interface LatestFMTransactionsProps {
  isLoading: boolean;
  data: GetTransactionsWithReceiptDto[];
}

export const LatestFMTransactions: FC<LatestFMTransactionsProps> = ({
  isLoading,
  data,
}) => {
  const navigate = useNavigate();
  const [receiptImageIds, setReceiptImageIds] = useState<string[] | undefined>(
    undefined
  );

  const { receiptImages: receiptImageUrls, ImageUrlsLoading } = useUrlsToImages(
    {
      receiptImageIds,
      useReceiptImages,
    }
  );

  const imageUrlToTypeMap = useFileUrlToTypeMapping(receiptImageUrls);

  const handleReceiptImageClick = useCallback((imageIds: string[]) => {
    setReceiptImageIds(imageIds);
  }, []);

  const handleCloseImageGallery = useCallback(() => {
    setReceiptImageIds(undefined);
  }, []);

  const handleViewAll = useCallback(() => {
    navigate(fmAppMainPages.TRANSACTIONS);
  }, [navigate]);

  return (
    <LatestFMTransactionsView
      isLoading={isLoading}
      data={data}
      onViewAll={handleViewAll}
      receiptImageUrls={receiptImageUrls || []}
      imageUrlsLoading={ImageUrlsLoading}
      imageUrlToTypeMap={imageUrlToTypeMap}
      receiptImageIds={receiptImageIds}
      onReceiptImageClick={handleReceiptImageClick}
      onCloseImageGallery={handleCloseImageGallery}
    />
  );
};
